import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/depositoRecibo';
import DepositoReciboForm from './DepositoReciboFormTabs';


const ms2p = (state) => {
  return {
    ...state.deposito_recibo_prd,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(DepositoReciboForm);
